import fetch from "../fetch";

export default ({ params }) =>
  fetch({
    path: `/common/ratings`,
    params
  });
